"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = ({
  title: r,
  titleId: t,
  desc: n,
  descId: i,
  ...o
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    "aria-hidden": "true",
    viewBox: "-.75 -.75 16 16",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": t,
    "aria-describedby": i,
    ...o,
    children: [
      r ? /* @__PURE__ */ e("title", { id: t, children: r }) : null,
      n === void 0 ? /* @__PURE__ */ e("desc", { id: i, children: `
    Chevron Left Streamline Icon: https://streamlinehq.com
  ` }) : n ? /* @__PURE__ */ e("desc", { id: i, children: n }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M10.4796 13.709 4.0204 7.25 10.4796.791"
        }
      )
    ]
  }
);
export {
  d as default
};
//# sourceMappingURL=ChevronLeftOutline.js.map
